import { FC, ReactNode } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import palette from 'style/palette'
import ErrorIcon from 'svgIcons/ErrorIcon'

type Color = 'primary' | 'text' | 'error' | 'hint'

interface StyleProps {
  color: string
  iconColor: string
}

export const STYLE_VALUE_OF_COLOR: {
  [key in Color]: StyleProps
} = {
  primary: {
    color: palette.primary.main,
    iconColor: palette.primary.main,
  },
  error: {
    color: palette.error.light,
    iconColor: palette.error.light,
  },
  text: {
    color: palette.text.primary,
    iconColor: '#707070',
  },
  hint: {
    color: palette.text.hint,
    iconColor: palette.text.hint,
  },
}

interface HelperTextWithIconProps {
  text: string
  icon?: ReactNode
  color?: Color
  className?: string
}

const HelperTextWithIcon: FC<HelperTextWithIconProps> = ({
  text,
  icon = <ErrorIcon />,
  color = 'primary',
  className,
}) => {
  const classes = useStyle(STYLE_VALUE_OF_COLOR[color])

  return (
    <div className={clsx(classes.root, className)}>
      {icon}
      <span className={classes.helperText}>{text}</span>
    </div>
  )
}

export default HelperTextWithIcon

const useStyle = makeStyles<Theme, StyleProps>(() => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      color: ({ color }) => color,
      fontWeight: 500,
      '& > svg > path': {
        fill: ({ iconColor }) => iconColor,
      },
    },
    helperText: {
      marginLeft: 6,
    },
  }
})
